import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router';
import InlineSvg from 'vue-inline-svg';
import App from './App.vue'
import Main from "./components/main/Main";
import Pricing from "./components/pricing/Pricing";
import PageNotFound from "./components/404";

const routes = [
  { name: 'main', path: '/', component: Main },
  { name: 'pricing', path: '/pricing', component: Pricing },
  { name: '404', path: '/:pathMatch(.*)', component: PageNotFound },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(() => {
  window.scrollTo(0, 0);
});

const app = createApp(App);

app.use(router);

app.component('inline-svg', InlineSvg);

app.config.globalProperties.urlQuery = window.location.search;
app.config.globalProperties.signupUrl = `https://app.coverse.team/signup${app.config.globalProperties.urlQuery}`;
app.config.globalProperties.signupUrlPro = `https://app.coverse.team/signup${app.config.globalProperties.urlQuery === '' ? '?get=pro' : `${app.config.globalProperties.urlQuery}&get=pro`}`;

app.mount('#app')
